import dayjs from 'dayjs';
import { useNavigate } from 'hooks';
import { Button } from 'components/button';
import { Flex } from 'components/flex';
import * as Styles from './styles';

const usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

// Show time; the year instead of the time when it was not paid this year, so the line
// still fits a phone (the full time stays in the tooltip).
function PaidTime({ paidAt, timezone }: { paidAt: string; timezone?: string | null }) {
  const local = (value?: string) => (timezone ? dayjs(value).tz(timezone) : dayjs(value));
  const paid = local(paidAt);
  return <time dateTime={paidAt} title={paid.format('MMM D, YYYY, h:mm A')}>
    {paid.format(paid.isSame(local(), 'year') ? 'MMM D, h:mm A' : 'MMM D, YYYY')}
  </time>;
}

export function CompletionAlertCard({ alert, close }: {
  alert: { eventId: number; eventName: string; sessionName: string; isCurrentSession: boolean; paidAt?: string | null; paidAmountCents?: number; timezone?: string | null };
  close: () => void;
}) {
  const navigate = useNavigate();
  return <div style={{ padding: 16, borderBottom: '1px solid #e8e8e8' }}>
    <Flex column gap={8}>
      <Styles.Title>Pending sale to be completed</Styles.Title>
      <strong>{alert.eventName}</strong>
      {/* Owner 22 Oct 2026: when the card was paid (show time), so an old sale is obvious. */}
      {alert.paidAt && <p>
        {alert.paidAmountCents != null && `${usd.format(alert.paidAmountCents / 100)} paid `}
        <PaidTime paidAt={alert.paidAt} timezone={alert.timezone} />
      </p>}
      {alert.isCurrentSession ? <>
        <p>Finish the saved sale in Receipts with a manager PIN.</p>
        <Button text="Open Receipts" onClick={() => { close(); navigate('/products/' + alert.eventId + '/receipts'); }} />
      </> : <p>On the POS signed in as {alert.sessionName}, open Receipts and finish the saved sale with a manager PIN.</p>}
    </Flex>
  </div>;
}
